<template>
  <el-dialog
    :title="$t('contract.mutliContractManage')"
    :close-on-click-modal="false"
    :visible.sync="visible"
    @close="closeCancelDlg"
    width="800px"
    class="contract-upload-modal-contain"
  >
    <div class="contract-upload-operate clearfix">
      <el-upload
        class="contract-upload-import"
        ref="upload"
        accept=".xls,.xlsx"
        :action="url"
        :show-file-list="false"
        :multiple="false"
        :auto-upload="false"
        :on-change="changeFile"
        :http-request="uploadContractFile"
      >
        <el-input
          v-model="fileName"
          :disabled="true"
          class="import-excel-input"
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-upload2"
          style="margin-left: 20px"
          :loading="loading"
          >{{ $t("pop.choseFile") }}</el-button
        >
      </el-upload>
      <el-button
        type="primary"
        icon="el-icon-download"
        @click="downTemplate"
        :loading="loading2"
        >{{ $t("pop.downloadtemplate") }}</el-button
      >
    </div>
    <div class="contract-upload-info" v-if="status === 1 || status === -1">
      {{ status == 1 ? $t("pop.mutliuplateSuccess") : $t("pop.mutliuplateError") }}
      <div class="download-a el-icon-cloudy" @click="downLoadFile">{{ downloadName }}</div>
    </div>
    <div class="contract-upload-footer">
      <el-button
        @click="visible = false"
        :loading="loading || loading2"
        style="width: 88px"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "contract-batch-up",
  data() {
    return {
      loading: false,
      loading2: false,
      visible: false,
      errorInfo: false,
      fileName: "",
      status: 0,
      downloadName: "",
      download: "",
      src: "",
      url: "/rm/trainer/importContracts",
      timeout: null,
    };
  },
  created() {
    this.fileName = "";
    this.visible = true;
    this.status = 0;
  },
  methods: {
    changeFile(file) {
      this.fileName = "";
      if (file) {
        if (file.status === "ready") {
          this.$refs.upload.submit();
        }
      }
    },
    uploadContractFile(params) {
      if (params.file) {
        this.loading = true;
        let formData = new FormData();
        this.fileName = params.file.name;
        this.status = 0;
        formData.append("file", params.file);
        this.$request
          .post(this.url, formData)
          .then((res) => {
            if (res) {
              this.status = res.status;
              let bstr = window.atob(res.data);
              let n = bstr.length;
              let u8arr = new Uint8Array(n);
              while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
              }
              this.loading = false;
              let blob = new Blob([u8arr], {
                type: "application/vnd.ms-excel",
              });

              let url = URL.createObjectURL(blob);
              this.downloadName = this.$t('contract.trainerContractMulti');
              this.src = url;
              this.download = this.downloadName;
              this.$refs.upload.clearFiles();
            }
          })
          .catch(() => {
            this.loading = false;
            this.status = 0;
          });
      }
    },
    downLoadFile () {
      let a = document.createElement('a')
      a.download = this.downloadName
      a.href = this.src
      document.getElementsByTagName('body')[0].appendChild(a)
      a.click()
      document.getElementsByTagName('body')[0].removeChild(a)
    },
    // 导出模板
    downTemplate() {
      this.loading2 = true;
      const name = this.$t('contract.trainerContractTemplate') + '.xlsx'
      this.$request.download(
        '/rm/trainer/downtemplate',
        name,
        { fileName: 'trainer_contract_temple.xlsx' }, null, "xlsx"
      );
      this.loading2 = false
    },
    // 取消
    closeCancelDlg() {
      this.visible = false;
      this.$emit("closeCancelDlg");
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    this.timeout = null;
  },
};
</script>
<style lang="scss" scoped>
.contract-upload-modal-contain {
  .contract-upload-operate {
    padding-bottom: 20px;
    border-bottom: 1px dashed #b2b0b4;
    .contract-upload-import {
      float: left;
      width: 70%;
      margin-right: 20px;
      .el-upload {
        width: 100% !important;
      }
      .import-excel-input {
        width: calc(100% - 150px) !important;
      }
    }
    .operate-button {
      float: left;
    }
    .line {
      height: 1px;
      margin: 10px;
    }
  }
  .contract-upload-info {
    margin: 20px 0;
    border: 1px solid #b2b0b4;
    border-radius: 4px;
    height: 60px;
    padding: 10px;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    .download-a {
      margin-left: 20px;
      text-indent: 10px;
      color: #409eff;
      cursor: pointer;
    }
  }
  .contract-upload-footer {
    text-align: center;
    margin-top: 20px;
  }
}
</style>
<style lang="scss">
.contract-upload-import {
  .el-upload {
    width: 100% !important;
    padding: 0 !important;
    border-radius: 0 !important;
  }
}
</style>
